import React from 'react'

import Step3 from '@appointment-planner/components/vertical/Step3'

const Step3Container = () => {
  return <Step3 />
}

export default React.memo(Step3Container)
